import { AbstractApi } from './abstract-api.js';
import { WishlistBrandRecommendation } from '../../@types/wishlist.js';

export interface BrandRecommendationsApi {
  listRecommendations(endpoint: string): Promise<WishlistBrandRecommendation[]>;
}

class BrandRecommendationsApiClass extends AbstractApi implements BrandRecommendationsApi {
  async listRecommendations(endpoint: string): Promise<WishlistBrandRecommendation[]> {
    return this.get<WishlistBrandRecommendation[]>(endpoint, 'BrandRecommendations');
  }
}

export const brandRecommendationsApi: BrandRecommendationsApi = new BrandRecommendationsApiClass();
